module.exports = __webpack_public_path__ + "img/imagem-indisponivel.9018502b.png";